import { render } from "./MobileExpandedSettings.vue?vue&type=template&id=61bf1a78&scoped=true&ts=true&lang=pug"
import script from "./MobileExpandedSettings.vue?vue&type=script&lang=ts"
export * from "./MobileExpandedSettings.vue?vue&type=script&lang=ts"

import "./MobileExpandedSettings.vue?vue&type=style&index=0&id=61bf1a78&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61bf1a78"]])

export default __exports__